<!--
	PartnerOrgSettingsPage.svelte
-->

<script>
    import { onMount } from 'svelte';
    import { fly, fade } from 'svelte/transition';

    // TCARE components
    import PageBanner from '../../components/common/PageBanner.svelte';

    // SMUI components
    
    onMount(() => {
        window.scrollTo(0, 0);          // do this for all other pages!
    })

    
</script>

<style>
    :global(.partners-page .mdc-button) {
        width: 250px;
    }

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>


<div class="page-content partners-page" in:fly="{{ x: 200, duration: 500 }}" out:fade="{{ duration: 250 }}">

    <div class="spacer-h-25"></div>
    <PageBanner title="Partner Organizations Settings"/>
    <div class="spacer-h-25"></div>

    <div class="fs-2 ta-l" >
        Partners Organizational Settings Page TBA.
    </div>


</div>
